








































































































































import { ciAngleRight } from '~/icons/source/light/angle-right'
import { mapActions, mapGetters } from 'vuex'
import { PAGE_NS } from '~/store/modules/shared/page/state'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import { mapDeps } from '~/plugins/dependency-container/utils'
import LanguageSwitcher from '~/services/LanguageSwitcher'
import { I18N_NS } from '~/store/modules/shared/i18n/state'
import { defineComponent, useFetch } from '~/utils/nuxt3-migration'
import { useNamespacedStore } from '~/compositions/store'
import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'
import UserAgentService from '~/services/UserAgentService'
import { USER_NS } from '~/store/modules/shared/user/state'
import { ciFacebook } from '~/icons/source/solid/facebook'
import { ciInstagram } from '~/icons/source/solid/instagram'
import { ciYoutube } from '~/icons/source/solid/youtube'
import { ciTiktok } from '~/icons/source/solid/tiktok'

export default defineComponent({
  components: {
    CImg
  },
  props: {
    availableLocales: {
      type: Array,
      required: false,
      default: () => {
        return []
      }
    }
  },
  setup() {
    const { dispatch: pageDispatch } = useNamespacedStore(PAGE_NS)

    useFetch(async () => {
      await pageDispatch('addBodyClass', 'has-footer')
    })
  },
  computed: {
    ...mapGetters(USER_NS, {
      isAnon: 'isAnon'
    }),
    ...mapDeps({
      languageSwitcher: LanguageSwitcher,
      userAgentService: UserAgentService,
      legacyUrlService: LegacyUrlService
    }),
    ...mapGetters(I18N_NS, { localeIsActive: 'localeIsActive' }),
    currentYear() {
      return new Date().getFullYear()
    },
    icons() {
      return {
        angleRight: ciAngleRight
      }
    },
    footerMenu() {
      return [
        {
          column_menus: [
            {
              menu_title: 'Car',
              mobile_collapsible: true,
              links: [
                {
                  title: this.$t('support'),
                  url: '/information/contact/'
                },
                {
                  title: this.$t('market guide'),
                  url: '/information/simboulos/'
                },
                {
                  title: 'Blog - Car.gr',
                  url: 'https://blog.car.gr/'
                },
                {
                  title: this.$t('deals'),
                  url: '/deals/'
                },
                {
                  title: this.$t('job offers'),
                  url: '/information/careers/'
                },
                {
                  title: this.$t('about_us'),
                  url: '/about-us/'
                }
              ]
            }
          ]
        },
        {
          column_menus: [
            {
              menu_title: this.$t('dealers'),
              mobile_collapsible: true,
              links: [
                {
                  title: this.$t('register'),
                  url: '/dealers/register/',
                  hide: !this.isAnon
                },
                {
                  title: this.$t('login'),
                  url: '/login/',
                  hide: !this.isAnon
                },
                {
                  title: this.$t('frequently asked questions'),
                  url: '/information/dealers_faq/'
                },
                {
                  title: this.$t('advertise at car'),
                  url: '/advertising'
                }
              ]
            }
          ]
        },
        {
          column_menus: [
            {
              menu_title: this.$t('individuals'),
              mobile_collapsible: true,
              links: [
                {
                  title: this.$t('register'),
                  url: this.legacyUrlService.getRegisterUrl(),
                  hide: !this.isAnon
                },
                {
                  title: this.$t('login'),
                  url: this.legacyUrlService.getUserLoginUrl(),
                  hide: !this.isAnon
                },
                {
                  title: this.$t('frequently asked questions'),
                  url: '/information/users_faq/'
                }
              ]
            }
          ]
        },
        {
          extra_classes: 'socials-and-apps',
          column_menus: [
            {
              menu_title: 'Follow us',
              mobile_collapsible: false,
              links: [
                {
                  title: 'Facebook',
                  hideLabel: true,
                  url: 'https://www.facebook.com/Car.grOfficial/',
                  icon: { type: 'icon', icon: ciFacebook },
                  target: '_blank',
                  rel: 'noreferrer'
                },
                {
                  title: 'Instagram',
                  hideLabel: true,
                  url: 'https://www.instagram.com/car.grofficial/',
                  icon: { type: 'icon', icon: ciInstagram },
                  target: '_blank',
                  rel: 'noreferrer'
                },
                {
                  title: 'YouTube',
                  hideLabel: true,
                  url: 'https://www.youtube.com/c/cargr?sub_confirmation=1',
                  icon: { type: 'icon', icon: ciYoutube },
                  target: '_blank',
                  rel: 'noreferrer'
                },
                {
                  title: 'TikTok',
                  hideLabel: true,
                  url: 'https://www.tiktok.com/@car.grofficial',
                  icon: { type: 'icon', icon: ciTiktok },
                  target: '_blank',
                  rel: 'noreferrer'
                }
              ]
            },
            {
              menu_title: 'Mobile apps',
              mobile_collapsible: false,
              links_class: 'apps',
              links: [
                {
                  title: 'Android',
                  hideLabel: true,
                  url:
                    'https://play.google.com/store/apps/details?id=com.car.gr',
                  target: '_blank',
                  icon: {
                    type: 'img',
                    class: 'playstore',
                    src: require('~/assets/img/brands/google-play-store.svg'),
                    width: 27,
                    height: 27
                  },
                  extra_classes: !this.userAgentService.isAndroidOs()
                    ? 'max-sm:!tw-hidden'
                    : null,
                  rel: 'noreferrer'
                },
                {
                  title: 'iOS',
                  hideLabel: true,
                  url:
                    'https://itunes.apple.com/gr/app/car-gr/id1278899131?mt=8',
                  target: '_blank',
                  icon: {
                    type: 'img',
                    src: require('~/assets/img/brands/apple-ios-store.svg'),
                    width: 27,
                    height: 27
                  },
                  extra_classes: !this.userAgentService.isIos()
                    ? 'max-sm:!tw-hidden'
                    : null,
                  rel: 'noreferrer'
                },
                {
                  title: 'Huawei AppGallery',
                  hideLabel: true,
                  url: 'https://appgallery7.huawei.com/#/app/C101510159',
                  icon: {
                    type: 'img',
                    class: 'huawei',
                    src: require('~/assets/img/brands/huawei-app-gallery.svg'),
                    width: 27,
                    height: 27
                  },
                  extra_classes: !this.userAgentService.isAndroidOs()
                    ? 'max-sm:!tw-hidden'
                    : null,
                  rel: 'noreferrer'
                }
              ]
            }
          ]
        }
      ]
    }
  },
  beforeDestroy() {
    this.removeBodyClass('has-footer')
  },
  methods: {
    ...mapActions(PAGE_NS, {
      addBodyClass: 'addBodyClass',
      removeBodyClass: 'removeBodyClass'
    })
  }
})
